import { render, staticRenderFns } from "./TheFacts.vue?vue&type=template&id=e7dcd926&scoped=true&"
import script from "./TheFacts.vue?vue&type=script&lang=js&"
export * from "./TheFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dcd926",
  null
  
)

export default component.exports